module.exports = __webpack_public_path__ + "img/Copyright-Undetermined.59969fb2.svg";